export const newCaseNote = "NEW_CASE_NOTE";
export const Other = "Other";